import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  initialize() {
    this.originalUrl = window.location.href
  }

  change(event) {
    let paramName = event.currentTarget.name;
    let paramValue = event.currentTarget.value;
    let newUrl = this.updateURLParameter(paramName, paramValue, this.originalUrl);
    history.pushState(null, '', newUrl);
  }

  updateURLParameter(paramName, paramValue, url = window.location.href) {
    const currentUrl = new URL(url);
    const params = currentUrl.searchParams;

    params.set(paramName, paramValue);

    currentUrl.search = params.toString();
    return currentUrl.toString();
  }
}
